export const sectionIds = {
  hero: "hero",
  battle: "battle",
  howToPlay: "how-to-play",
  extraPowers: "extra-powers",
  tokenomics: "tokenomics"
};
